import { useCallback, useRef } from 'react';
var useDebounce = function (timeout) {
    var timer = useRef(null);
    var debounce = useCallback(function (fn) {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () {
            fn();
        }, timeout);
    }, [timeout]);
    return debounce;
};
export default useDebounce;
